import { apiMapper } from "./ApiMapper";
const UploadFileAPI = {
  UPLOAD: apiMapper.uploadFile.upload,
  DELETE: (axiosPrivate, id) => {
    return axiosPrivate.post(`${apiMapper.uploadFile.delete}${id}/`, {});
  },

  DOWNLOAD: (id) => {
    return `${apiMapper.uploadFile.download}${id}/`;
  },

  EXTRACT_FILE_DATA: (docType) => {
    return `${apiMapper.uploadFile.extractFileData}?document_type=${docType}`;
  }
};

export default UploadFileAPI;
